/**
 * Looks up a patient that is already registered in CatTrax, so a duplicate can be
 * caught while the register form is being filled in rather than by the API.
 *
 * The API enforces uniqueness on (dateOfBirth, firstName, lastName) when the NHI
 * is empty, and on (dateOfBirth, firstName, lastName, nhi) when it is not. A clash
 * comes back as a 409 that leaves the user with nowhere to go, so we ask the same
 * question up front and offer them the existing record instead.
 */
app.service('PatientDuplicate', ['$q', 'PatientAPI', function ($q, PatientAPI) {

	function normalise(value) {
		return typeof value === 'string' ? value.trim().toLowerCase() : '';
	}

	/**
	 * Two records describe the same person unless both carry an NHI and those NHIs
	 * differ - that is the only case where the API accepts a shared name and date
	 * of birth as genuinely distinct patients.
	 */
	function nhiMatches(existingNhi, enteredNhi) {
		var existing = normalise(existingNhi);
		var entered = normalise(enteredNhi);
		return !existing || !entered || existing === entered;
	}

	var service = {

		/**
		 * Resolves with the registered patient matching these details, or null when
		 * there is none. Never rejects: a failed lookup must not block registration,
		 * it just leaves the server-side 409 as the backstop.
		 *
		 * @param firstName patient first name as entered
		 * @param lastName  patient last name as entered
		 * @param dob       date of birth as YYYY/MM/DD
		 * @param nhi       NHI as entered, may be empty
		 */
		findExisting: function (firstName, lastName, dob, nhi) {
			if (!normalise(firstName) || !normalise(lastName) || !dob) {
				return $q.resolve(null);
			}

			// Basic search matches last name case-insensitively and by substring on an
			// exact date of birth, so it is looser than the unique constraint: any
			// record that would clash is guaranteed to come back in these results.
			return PatientAPI.search(lastName, dob, '', '').then(
				function (resp) {
					var candidates = resp.data || [];
					var match = candidates.find(function (candidate) {
						return normalise(candidate.firstName) === normalise(firstName) &&
							normalise(candidate.lastName) === normalise(lastName) &&
							nhiMatches(candidate.nhi, nhi);
					});
					return match || null;
				},
				function () {
					return null;
				}
			);
		}
	};

	return service;
}])
